module.exports = __webpack_public_path__ + "media/images/contest-label-left@2x-71b2b6e35c157c196df4b67dad54f634.png";